import { render, staticRenderFns } from "./Berlinale2025Event.vue?vue&type=template&id=9e52743c&scoped=true"
import script from "./Berlinale2025Event.vue?vue&type=script&lang=js"
export * from "./Berlinale2025Event.vue?vue&type=script&lang=js"
import style0 from "./Berlinale2025Event.vue?vue&type=style&index=0&id=9e52743c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e52743c",
  null
  
)

export default component.exports